import React from 'react';
import PropTypes from 'prop-types';
import { reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';

import Button from '../../Button';
import Paragraph from '../../Paragraph';
import Readmore from '../../Paragraph/Readmore';
import Heading from '../../Heading';
import Progress from '../../Progress';
import { Row } from '../../Register/Scaffold';

const calcBMI = (kg, cm) => {
  const bmi = parseFloat(kg) / ((parseFloat(cm) / 100) * (parseFloat(cm) / 100));
  return bmi.toFixed(2);
};

class AllResults extends React.PureComponent {
  render() {
    const {
      handleSubmit, weight, height, activity, smokingamount, smoking, smokingtype, units, postassessment,
    } = this.props;

    const bmi = calcBMI(weight, height);

    let amount = smokingamount;
    if (smoking === 'No') {
      amount = '0';
    }
    let smokeType = '';
    if (smokingtype === '1517') {
      smokeType = 'Cigarettes';
    } else if (smokingtype === '1518') {
      smokeType = 'Cigars';
    } else if (smokingtype === '1617') {
      smokeType = 'Non-smoker';
    } else if (smokingtype === '1520') {
      smokeType = 'Pipe';
    } else if (smokingtype === '1521') {
      smokeType = 'Roll-ups';
    } else if (smokingtype === '1519') {
      smokeType = 'e-Cigarettes';
    }

    const basic = { title: '', message: '' };
    const empty = {
      activity: basic,
      alcohol: basic,
      weight: basic,
      smoking: basic,
    };
    const messages = postassessment && postassessment.messages ? postassessment.messages : empty;

    let ctaAction = <Button classes={['color-button']} label="Login to profile" onClick={() => { window.location = 'https://my.livewelldorset.co.uk'; }} />;

    const token = localStorage.getItem('access_token');
    if (token) {
      ctaAction = <Button classes={['color-button']} label="Go to profile" onClick={() => { window.location = 'https://my.livewelldorset.co.uk'; }} />;
    }

    return (
      <div className="register-all-results">
        <Progress step="all" />
        <div className="register-block step-one-block">
          <Heading tag="h1" classes="header-text purple" center><div>Thank you for your update.</div></Heading>
          <Paragraph classes="width-limited" center>Thanks for updating your progress. Below, you can see how you compare to your previous assessment. What's next? Well, as always, we're here for you. If you'd like to talk about your results or access further support, please phone or contact us.</Paragraph>
          <Paragraph classes="step-text" center>My Results</Paragraph>

          <form onSubmit={handleSubmit} className="form-register">
            <div className="results results-wrap flex-row four-cols">

                <div className="item green">
                  <div className="item-summary justifycentre">
                    <Paragraph classes="item-image">
                      <img src="https://livewelldorset.s3.amazonaws.com/Pathways/getactive-roundal.png" alt="" width="50" height="50" />
                    </Paragraph>
                    <Paragraph classes="item-title larger">Activity</Paragraph>
                    <Paragraph classes="item-times">{activity}</Paragraph>
                    <Paragraph classes="item-unit">activities per week</Paragraph>
                  </div>

                  <Paragraph classes="content-title">{messages.activity.title}</Paragraph>
                  <Paragraph>{messages.activity.message}</Paragraph>
                </div>

                <div className="item purple">
                  <div className="item-summary justifycentre">
                    <Paragraph classes="item-image">
                      <img src="https://livewelldorset.s3.amazonaws.com/Pathways/loseweight-roundal.png" alt="" width="50" height="50" />
                    </Paragraph>
                    <Paragraph classes="item-title larger">Weight</Paragraph>
                    <Paragraph classes="item-times">{bmi}</Paragraph>
                    <Paragraph classes="item-unit">BMI</Paragraph>
                  </div>

                  <Paragraph classes="content-title">{messages.weight.title}</Paragraph>
                  <Paragraph>{messages.weight.message}</Paragraph>
                </div>
                
                <div className="item red">
                  <div className="item-summary justifycentre">
                    <Paragraph classes="item-image">
                      <img src="https://livewelldorset.s3.amazonaws.com/Pathways/quitsmoking-roundal.png" alt="" width="50" height="50" />
                    </Paragraph>
                    <Paragraph classes="item-title larger">Smoking</Paragraph>
                    <Paragraph classes="item-times">{amount}</Paragraph>
                    <Paragraph classes="item-unit">{smokeType} per day</Paragraph>
                  </div>

                  <Paragraph classes="content-title">{messages.smoking.title}</Paragraph>
                  <Paragraph>{messages.smoking.message}</Paragraph>
                </div>
                
                <div className="item yellow">
                <div className="item-summary justifycentre">
                    <Paragraph classes="item-image">
                      <img src="https://livewelldorset.s3.amazonaws.com/Pathways/drink-less.png" alt="" width="50" height="50" />
                    </Paragraph>
                    <Paragraph classes="item-title larger">Drinking</Paragraph>
                    <Paragraph classes="item-times">{units}</Paragraph>
                    <Paragraph classes="item-unit">units per week</Paragraph>
                  </div>

                  <Paragraph classes="content-title">{messages.alcohol.title}</Paragraph>
                  <Paragraph>{messages.alcohol.message}</Paragraph>
                </div>
            </div>
          </form>
        </div>

        <div className="justifycentre register-block step-two-block">
          <Paragraph classes="larger width-limited">If you would like more support please do not hesitate to contact us on freephone 0800 8401628 or local number 01305 233105.</Paragraph>
          <Paragraph classes="button-groups">
            { ctaAction }
          </Paragraph>
        </div>

      </div>
    );
  }
}


AllResults.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
};

const FormBuilt = reduxForm({
  form: 'assessment', // <------ same form name
  destroyOnUnmount: false, // <------ preserve form data
  forceUnregisterOnUnmount: true, // <------ unregister fields on unmount
})(AllResults);


export default connect(state => ({
  postassessment: state.postassessment,
}), dispatch => ({ dispatch }))(FormBuilt);



// WEBPACK FOOTER //
// ./src/Components/Assessment/Pages/AllResults.jsx